"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ContextMenu = _interopRequireDefault(require("./templates/ContextMenu.html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _window = window,
    featureManager = _window.featureManager,
    url = _window.url,
    routes = _window.routes,
    OverDrive = _window.OverDrive,
    text = _window.text,
    html = _window.html;

var ContextMenu =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(ContextMenu, _Backbone$View);

  function ContextMenu() {
    var _this;

    _classCallCheck(this, ContextMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContextMenu).apply(this, arguments));
    _this.template = _ContextMenu["default"];

    _this.isKeyboardSelectEvent = function (e) {
      return (e.which === 13 || e.which === 32) && (e.preventDefault() || true);
    };

    _this.rid = Math.random().toString(36).substring(7);

    _this.listenTo(_this.model, 'change:isInHistory', function () {
      return _this.render();
    });

    _this.render();

    return _this;
  }

  _createClass(ContextMenu, [{
    key: "events",
    value: function events() {
      var events = {
        'click .js-historyAction': '_handleClick',
        'keydown .js-historyAction': '_handleKeyHistory',
        'keydown .js-context-button': 'toggle'
      };

      if (featureManager.isEnabled('cleanupContextMenuToggle')) {
        events['keyup .js-context-drop'] = '_handleKeyUpContainer';
      }

      return events;
    }
  }, {
    key: "_handleKeyUpContainer",
    value: function _handleKeyUpContainer(e) {
      if (e.keyCode === 27
      /*ESC*/
      ) {
          this.close();
        }
    }
  }, {
    key: "_handleClick",
    value: function _handleClick() {
      this.model.trigger('title:action', {
        action: 'history',
        model: this.model
      });
    }
  }, {
    key: "_handleKeyHistory",
    value: function _handleKeyHistory(e) {
      if (!window.featureManager.isEnabled('cleanupContextMenuToggle')) {
        e.stopImmediatePropagation();
      }

      if (e.keyCode === 13 || e.keyCode === 32) {
        if (window.featureManager.isEnabled('cleanupContextMenuToggle')) {
          e.stopImmediatePropagation();
        }

        this.model.trigger('title:action', {
          action: 'history',
          model: this.model
        });
      }
    }
  }, {
    key: "_getSampleText",
    value: function _getSampleText() {
      var type = this.model.get('type').id;

      if (type === 'audiobook' || type === 'music') {
        return text('sampleListen');
      } else if (type === 'video') {
        return text('sampleWatch');
      }

      return text('sampleRead');
    }
  }, {
    key: "_getHistoryActionLabel",
    value: function _getHistoryActionLabel() {
      var title = this.model.get('title');

      if (this.model.get('isInHistory')) {
        return html('readingHistory.removeTitle', {
          title: title
        });
      } else {
        return html('readingHistory.addTitle', {
          title: title
        });
      }
    }
  }, {
    key: "_getHistoryActionText",
    value: function _getHistoryActionText() {
      if (this.model.get('isInHistory')) {
        return html('readingHistory.remove');
      } else {
        return html('readingHistory.add');
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.$el.empty().append(this.template(this.viewModel));
      return this;
    }
  }, {
    key: "close",
    value: function close() {
      window.Foundation.libs.dropdown.close(this.$el.find('.js-context-drop'));
    }
  }, {
    key: "toggle",
    value: function toggle(e) {
      if (this.isKeyboardSelectEvent(e)) {
        window.Foundation.libs.dropdown.toggle(this.$el.find('.js-context-button'));
      }
    }
  }, {
    key: "viewModel",
    get: function get() {
      var seriesSearchUrl = '';

      if (featureManager.isEnabled('enhancedSeries') && this.model.get('detailedSeries')) {
        seriesSearchUrl = url(routes.searchByType, {
          type: 'seriesId',
          query: this.model.get('detailedSeries').seriesId,
          sortBy: 'readingOrder'
        });
      } else if (this.model.get('series')) {
        seriesSearchUrl = url(routes.searchByType, {
          type: 'series',
          query: this.model.get('series'),
          sortBy: 'newlyadded'
        });
      }

      return {
        id: this.model.id,
        rid: this.rid,
        title: this.model.get('title'),
        typeId: this.model.get('type').id,
        sampleHref: this.model.get('sample').href || '',
        sampleText: this._getSampleText(),
        alignment: 'bottom',
        historyActionLabel: this._getHistoryActionLabel(),
        historyActionText: this._getHistoryActionText(),
        historyEnabled: OverDrive.showHistoryFeature && !this.model.get('isPreReleaseTitle'),
        gaHistoryAction: this.model.get('isInHistory') ? 'history-remove' : 'history-add',
        seriesSearchUrl: seriesSearchUrl
      };
    }
  }]);

  return ContextMenu;
}(Backbone.View);

exports["default"] = ContextMenu;